import React from "react";
import InspectionType from "../../scenes/requirements/InspectionType";
import InspectionDetails from "../../scenes/requirements/InspectionDetails";

const RequirementsTabContent = ({
  menuInspections,
  getSelectedInspection,
  displayInspectionID,
  tab,
}) => {
  return (
    <>
      <div className="flex flex-col gap-2 items-center">
        <div className="w-full">
          <InspectionType
            inspections={menuInspections}
            getSelectedInspection={getSelectedInspection}
          />
        </div>
      </div>
      <div>
        <InspectionDetails
          inspectionID={displayInspectionID}
          tab={tab}
        />
      </div>
    </>
  );
};

export default RequirementsTabContent;
